import * as _ from 'lodash';

import { IAction, ActionType } from "../../classes/actiontype";

export interface IFavoritesState {
    isFavorite: boolean;
    pageKey: string;
    isLoggedIn: boolean;
}

export const defaultFavoritesState: IFavoritesState = {
    isFavorite: false,
    pageKey: "",
    isLoggedIn: false
};

export default function favoritesReducer(state: IFavoritesState = defaultFavoritesState, action: IAction) {
    switch (action.type) {
        case ActionType.IS_FAVORITED: {
            return _.assign({}, state, { isFavorite: true });
        }

        case ActionType.IS_UNFAVORITED: {
            return _.assign({}, state, { isFavorite: false });
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/redux/reducers/favorites-reducer.ts